export const formatPrice = (price?: number | string | null) => {
  if (price === null || price === undefined || typeof price === "string") {
    return "?";
  }

  const formattedPrice = Math.floor(price * 100) / 100;
  const hasDecimal = formattedPrice % 1 !== 0;

  return hasDecimal
    ? formattedPrice
        .toLocaleString("nb-NO", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
        .replace(".", ",")
    : `${formattedPrice.toLocaleString("nb-NO")},-`;
};
